export default "__VITE_ASSET__8f5dc417__"